'use client';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';
import parse from 'html-react-parser';
import Image from 'next/image';
import { useState } from 'react';

import { icons } from '@/assets/icons';
import { FAQ_ITEMS_FULL } from '@/global/constants/common';

export const FAQFullSection = () => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange = (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const renderContent = (htmlContent: string) => {
    return (
      <Typography
        fontSize={{ xs: '14px', md: '18px' }}
        variant={'bodyLarge'}
        color={'#FFFFFF'}
        className={'mix-blend'}
        sx={{
          whiteSpace: 'unset',
          '& ul': {
            marginLeft: { xs: '10px', md: '30px' },
          },
          '& ol': {
            marginLeft: { xs: '10px', md: '30px' },
          },
          '& a': {
            textDecoration: 'underline',
            '& > span': {
              fontWeight: '600 !important',
            },
          },
        }}>
        {parse(htmlContent)}
      </Typography>
    );
  };

  return (
    <Stack
      width={'100%'}
      height={'100%'}
      flexGrow={1}
      alignItems={'center'}
      component={'section'}
      position={'relative'}>
      <Stack alignItems={'center'} padding={{ xs: '100px 24px 40px', md: '80px' }} zIndex={2}>
        <Stack gap={{ xs: 3, md: 7 }} width={'min(1280px, 100%)'} alignItems={'center'}>
          <Typography
            component={'h2'}
            variant={'displayMedium'}
            className={'clip-text'}
            textAlign={'center'}
            whiteSpace={'pre-line'}
            fontSize={{ xs: '24px', md: '48px' }}
            lineHeight={{ xs: '32px', md: '68px' }}
            sx={{ background: 'linear-gradient(90deg, #A9A9A9 0%, #FFFFFF 50%, #A9A9A9 100%)' }}>
            FREQUENTLY ASKED
            {'\n'}
            <span style={{ WebkitTextFillColor: '#FF5319' }}>QUESTIONS</span>
          </Typography>
          <Stack width={'min(838px, 100%)'}>
            {FAQ_ITEMS_FULL.map((item, index) => {
              const panel = `panel-${index}`;
              return (
                <Accordion
                  key={index}
                  expanded={expanded === panel}
                  onChange={handleChange(panel)}
                  sx={{
                    '&.MuiAccordion-root': {
                      borderRadius: 0,
                      overflow: 'hidden',
                      boxShadow: 'unset',
                      backgroundColor: 'transparent',
                      padding: { xs: '24px 0px', md: '40px 0px' },
                      borderBottom: '1px solid #FFFFFF33',
                      '&.Mui-expanded': {
                        margin: 0,
                      },
                    },
                  }}>
                  <AccordionSummary
                    expandIcon={
                      expanded === panel ? (
                        <RemoveIcon style={{ color: '#FFF' }} />
                      ) : (
                        <AddIcon style={{ color: '#FFF' }} />
                      )
                    }
                    sx={{
                      '&.MuiAccordionSummary-root': {
                        padding: 0,
                      },
                    }}>
                    <Typography
                      fontSize={{ xs: '18px', md: '24px' }}
                      component={'span'}
                      variant={'headLarge2'}
                      color={'#FFF'}>{`${item.question}`}</Typography>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      '&.MuiAccordionDetails-root': {
                        padding: 0,
                      },
                    }}>
                    {renderContent(item.answer)}
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Stack>
        </Stack>
      </Stack>
      <Stack zIndex={1} position={'absolute'} top={0} left={0} right={0} bottom={0}>
        <Image src={icons.ic_wave_section} alt={''} layout={'fill'} objectFit={'cover'} />
      </Stack>
    </Stack>
  );
};
